module.exports = __webpack_public_path__ + "img/graph_4.74a0c588.svg";